<template>
  <el-drawer
    title="DETALLE DE SLA"
    :visible.sync="drawer"
    size="80%"
    :before-close="handleBeforeClose"
    :append-to-body="true"
  >
    <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
      <el-row style="padding: 20px">
        <table style="font-size: 25px" id="table-card">
          <tr style="font-size: 25px">
            <td>Soporte:</td>
            <td>
              <strong> {{ tecnico }}</strong>
            </td>
          </tr>
        </table>
      </el-row>
    </el-col>

    <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
      <el-row style="padding: 20px">
        <table style="font-size: 25px" id="table-card">
          <tr>
            <td>
              <strong> {{ month }}</strong>
            </td>
          </tr>
        </table>
      </el-row>
    </el-col>
    <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
      <el-row style="padding: 20px">
        <table style="font-size: 25px" id="table-card">
          <tr style="font-size: 20px">
            <td>A tiempo:</td>
            <td>
              <strong> {{ TotalCumplida }}</strong>
            </td>
          </tr>
          <tr style="font-size: 20px">
            <td>Tarde:</td>
            <td>
              <strong>{{ TotalFallida }}</strong>
            </td>
          </tr>
          <tr style="font-size: 20px">
            <td>Total:</td>
            <td>
              <strong> {{ Total }}</strong>
            </td>
          </tr>
          <tr style="font-size: 20px">
            <td>Cumplimiento:</td>
            <td>
              <el-tag :type="getTagType" style="font-size: 25px">{{
                percent
              }}</el-tag>
            </td>
          </tr>
        </table>
      </el-row>
    </el-col>
    <div>
      <div class="text-right">
        <p>
          :
          <span class="label label-danger" style="font-size: 22px">
            <template> </template>
          </span>
        </p>
      </div>

      <el-row style="padding: 20px">
        <RabbeyTable3
          ref="table"
          v-loading="loadingDetails"
          :columns="columnsDetails"
          :summary-method="getSummariesKPI"
          :data="RegisteredKPISupport"
          :height="560"
        />
      </el-row>
    </div>
  </el-drawer>
</template>

<script>
import {
  formatMontoKPI,
  FormatPercentSalesKpi,
  GetMonthInLetterBeginingOnZero
} from "@/utils";
import { getSummariesKPI } from "@/helpers/TableRabbeyTools";
// import DetailTechnicalSupportKpi from "./DetailTechnicalSupportKpi.vue";
import { DetailTechnicalSupportKpi } from "@/helpers/TechnicalSupportColumns";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";

export default {
  name: "DetailTechnicalSupportKpi",
  components: {
    RabbeyTable3
  },
  data() {
    return {
      metaMount: 0,
      RegisteredKPISupport: [],
      drawer: false,
      month: "",
      SellerName: "",
      tecnico: "",
      tecnicoID: "",
      serviceTypeId: null,
      DirecctionID: "",
      productId: null,
      columnsDetails: [...DetailTechnicalSupportKpi],
      loadingDetails: false,
      slaTracker: {
        Failed: 0,
        Compliment: 1
      }
    };
  },
  computed: {
    Total: function () {
      return this.RegisteredKPISupport.length;
    },
    TotalCumplida: function () {
      return this.RegisteredKPISupport.filter((r) => r.Status === "Cumplida")
        .length;
    },
    TotalFallida: function () {
      return this.RegisteredKPISupport.filter((r) => r.Status === "Fallida")
        .length;
    },
    percent: function () {
      return formatMontoKPI((this.TotalCumplida / this.Total) * 100) + "%";
    },
    getTagType() {
      if (this.percent.replace("%", "") <= 70) {
        return "danger";
      } else if (this.percent.replace("%", "") >= 95) {
        return "success";
      } else if (
        this.percent.replace("%", "") >= 80 &&
        this.percent.replace("%", "") <= 95
      ) {
        return "warning";
      }
      return "info";
    }
  },

  methods: {
    FormatPercentSalesKpi,
    formatMontoKPI,
    getSummariesKPI,
    async show(row, month, year) {
      const monthT = GetMonthInLetterBeginingOnZero(month - 1);
      this.month = this.$t(`months.${monthT}`);
      this.tecnico = row.technical;
      this.tecnicoID = row.technicalId;
      this.serviceTypeId = row.currentServiceTypeId;
      this.productId = row.currentProductId;
      this.DirecctionID = row.DirecctionID;

      this.DirecctionID > 0
        ? await this.getDetailsinforSLAGerencia(month, year)
        : this.getDetailsinfoSLA(month, year);

      this.drawer = true;
    },
    async getDetailsinfoSLA(month = Number, year = Number) {
      this.loadingDetails = true;
      const param = {
        mes: month,
        tecnicoID: this.tecnicoID,
        serviceTypeID: this.serviceTypeId,
        product: this.productId,
        year: year,
        companyID: this.currentCompany
      };
      const api = `/api/KpiTechnicalSupport/GetKpiSupportDetailbyTechnicalInternal`;
      await this.$http
        .get(api, { params: param })
        .then(({ data }) => {
          this.RegisteredKPISupport = data;
          this.loadingDetails = false;
        })
        .catch((error) => {
          this.$message.error("Error al consultar el detalle");
          console.error(error);
        })
        .finally(() => {
          this.loadingDetails = false;
        });
    },
    async getDetailsinforSLAGerencia(month, year) {
      this.loadingDetails = true;
      const param = {
        year: year,
        companyID: this.currentCompany,
        directionId: this.DirecctionID,
        mes: month,
        TypeRequest: 0
      };
      const api = `/api/KpiTechnicalSupport/GetKpiSupportDetailbyTechnicalInternalGerencia`;
      await this.$http
        .get(api, { params: param })
        .then(({ data }) => {
          this.RegisteredKPISupport = data;
          this.loadingDetails = false;
        })
        .catch((error) => {
          this.$message.error("Error al consultar el detalle");
          console.error(error);
        })
        .finally(() => {
          this.loadingDetails = false;
        });
    },
    handleBeforeClose(done) {
      done();
      this.drawer = false;
    }
  }
};
</script>
